// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-f5d5fb48] {color: #000; text-decoration: none; cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
